<template>
  <form id="infractionTypeForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('infraction_type_code') }"
    >
      <label for="infraction_type_code">{{ $t("infraction_type_code") }}</label>
      <input
        type="text"
        id="infraction_type_code"
        name="infraction_type_code"
        class="form-control"
        :placeholder="$t('ph_infraction_type_code')"
        v-model="infractionType.codigo_infracao_tipo"
        v-validate="'required'"
      />

      <small v-show="errors.has('infraction_type_code')" class="form-text">
        {{ errors.first("infraction_type_code") }}
      </small>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors.has('infraction_type_description') }"
    >
      <label for="infraction_type_description">{{
        $t("infraction_type_description")
      }}</label>
      <input
        type="text"
        id="infraction_type_description"
        name="infraction_type_description"
        class="form-control"
        :placeholder="$t('ph_infraction_type_description')"
        v-model="infractionType.descricao_infracao_tipo"
        v-validate="'required'"
        @input="infractionType.descricao_infracao_tipo = infractionType.descricao_infracao_tipo.toUpperCase()"
      />

      <small
        v-show="errors.has('infraction_type_description')"
        class="form-text"
      >
        {{ errors.first("infraction_type_description") }}
      </small>
    </div>

    <div class="form-group">
      <label for="infraction_level">{{ $t("infraction_level") }}</label>
      <Combobox
        class="bg-white"
        name="infraction_level"
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('infraction_level')"
        :options="infractionsLevels"
        :initial-value="infractionType.nivel_infracao_tipo"
        v-model="infractionType.nivel_infracao_tipo"
        v-validate="'required'"
      />

      <small
        v-show="errors.has('infraction_level')"
        class="form-text text-muted"
      >
        {{ errors.first("infraction_level") }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="ativo_infracao_tipo">{{ $t("active") }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="ativo_infracao_tipo"
          v-model="infractionType.ativo_infracao_tipo"
        />
        <label class="onoffswitch2-label" for="ativo_infracao_tipo">
          <span class="onoffswitch2-inner"></span>
          <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox.vue";
import infractionsLevels from "@/config/infractionLevels";

export default {
  name: "InfractionTypeForm",

  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      infractionsLevels,
    };
  },

  props: {
    infractionType: {
      type: Object,
      default: () => ({
        id: null,
        codigo_infracao_tipo: "",
        descricao_infracao_tipo: "",
        ativo_infracao_tipo: true,
        nivel_infracao_tipo: "",
      }),
    },
  },

  methods: {
    ...mapActions("infractiontype", ["create", "edit"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));
        this.$store.dispatch("notify/error", err);
        return;
      }

      const { id, ...rest } = this.infractionType;

      const result = id
        ? await this.edit({ id, data: rest })
        : await this.create(rest);

      if (result) {
        this.$router.push({ name: "listinfractionstypes" });
      }
    },
  },
};
</script>
